import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';

import { BrandThemesEnum, SdHtmlComponent, SdSpyTargetDirective, SdTitleComponent } from '@seb/web-design-system/core';
import { IDocument, SdDocumentsComponent } from '@seb/web-design-system/documents';

import { CmsLinkDSComponentInterface, WarrantyComponentInterface } from '../../../models';
import { AbstractModuleComponent } from '../abstract-module.component';
import { TrackingService } from '../../../services';
import { DocumentMapper } from '../../../mappers';

@Component({
  selector: 'wc-warranty',
  templateUrl: './warranty.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdSpyTargetDirective,
    SdTitleComponent,
    SdDocumentsComponent,
    SdHtmlComponent
  ]
})
export class WarrantyComponent extends AbstractModuleComponent<WarrantyComponentInterface> implements OnInit {
  titleLevel: number;
  documents: IDocument[];
  headline: string;
  subline: string;
  disclaimer: string;
  brandThemesEnum = BrandThemesEnum;

  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'is-weird'].filter(Boolean).join(' ');
  }
  constructor(
    private documentMapper: DocumentMapper,
    private cdRef: ChangeDetectorRef,
    private trackingService: TrackingService
  ) {
    super();
  }

  override mandatoryFunction = (cmp: WarrantyComponentInterface): boolean => {
    return !!cmp.headline;
  };

  override mandatoryComponentFunction = (link: CmsLinkDSComponentInterface): boolean => {
    return !!link.linkName && !!link.media.url;
  };

  ngOnInit(): void {
    this.subscriptions.add(
      this.module$.subscribe((module: WarrantyComponentInterface) => {
        this.headline = module.headline;
        this.subline = module.subline;
        this.disclaimer = module.disclaimer;

        this.documents = module.componentsObjects.map((cmp) => ({
          link: this.documentMapper.normalizeUrl(cmp.media.url),
          title: cmp.linkName
        }));

        this.setLoaded();
        this.cdRef.markForCheck();
      })
    );
  }

  onClick(document: IDocument): void {
    this.trackingService.sendEvent('documentationDownload', {
      documentationName: document.title
    });
  }
}
